export const DISCOUNT_CODE_TYPE_MULTIPLE_TIMES = "multiple";
export const DISCOUNT_CODE_TYPE_ONCE = "once";
export const DISCOUNT_CODE_TYPE_ONCE_PER_USER = "once_per_user";
